<template>
  <div>
    <uploadfolder
      :id_registro="item.id"
      :titulo="item[field_name]"
      :onLoadData="onLoadData"
      :id_tabela="id_tabela"
      :enable_edit="enable_edit"
    ></uploadfolder>
  </div>
</template>
<script>
import uploadfolder from "../../components/images/uploadFolder";
import { type } from "os";

export default {
  components: { uploadfolder },
  props: {
    item: {
      type: Object,
      default: null
    },
    id_tabela: {
      type: String,
      default: "inspecao_item"
    },

    field_name: {
      type: String,
      default: "nome"
    },
    field_qtde: {
      type: String,
      default: null
    },
    enable_edit:{
          type: Boolean,
          default: true
    },
  },
  methods: {
    onLoadData(items) {
      if (
        this.field_qtde != null &&
        this.field_qtde != "" &&
        this.item != null
      ) {
        this.item[this.field_qtde] = items.length;
      }
    }
  }
};
</script>